<template>
    <VJoyWrapper no-margin direction="column" row-gap="4" align="stretch">
        <Wysiwyg
            v-model="state.description"
            class="profile-description-edition-section__wysiwyg"
            input-name="description"
            :minlength="resumeDescriptionLength.min"
            :minlength-label="t('profile.section.description.minLength.label', {0: resumeDescriptionLength.min})"
            :maxlength="resumeDescriptionLength.max"
            :placeholder="t('profile.section.description.placeholder')"
            :valid-label="t('profile.section.description.valid.label')"
            :valid-icon="'check-circle'"
            :valid-icon-color="'success'"
            :min-counter="true"
            :invalid="r$.description.$error"
            :strict-validation="true"
            data-testid="profile-description-wysiwyg"
        />
        <VJoyHighlight display-icon level="info">
            <span v-html="t('profile.section.description.edit.info')"></span>
        </VJoyHighlight>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {maxLength, minLength} from '@regle/rules';
    import {storeToRefs} from 'pinia';
    import {Wysiwyg} from '#components';
    import {useTranslation} from '#imports';
    import {VJoyHighlight, VJoyWrapper} from '@maltjoy/core-vue';
    import {useScopedRegleItem} from '~/features/about/types/EditAboutSection';
    import {useProfileStore} from '~/store/profileStore';
    import {useRulesStore} from '~/store/rules/rulesStore';

    const {resumeDescriptionLength} = storeToRefs(useRulesStore());
    const {profile} = storeToRefs(useProfileStore());

    const {t} = useTranslation();

    const rules = computed(() => ({
        description: {
            minLength: minLength(resumeDescriptionLength.value.min),
            maxLength: maxLength(resumeDescriptionLength.value.max),
        },
    }));
    const defaultState = computed(() => ({
        description: profile.value?.description ?? '',
    }));
    const state = ref({...defaultState.value});
    const {r$} = useScopedRegleItem(state, rules, {
        id: 'descriptionEdition',
    });
</script>

<style scoped lang="scss">
    .profile-description-edition-section {
        &__wysiwyg {
            width: 100%;

            :deep(.wysiwyg-editor__helpers) {
                margin-bottom: 0;
            }
        }
    }

    :deep(.joy-highlight__text) {
        ul {
            margin-top: 0;
            padding-top: 0;
        }
    }
</style>
